<template>
  <div class="flex flex-wrap reviews">
    <div class="flex w-full">
      <a
        href="/reports"
        class="vs-component vs-button self-end vs-button-primary vs-button-border ml-auto ml-5"
        icon-pack="feather"
        >Reports center</a
      >
    </div>
    <div class="w-full search-content-loading vs-con-loading__container">
      <vs-table-m
        @change-page="handleChangePageContentRatings"
        :sst="true"
        :total="contentRatings.total"
        :maxItems="pageSizeContentRatings"
        :data="contentRatings.items"
        pagination
        class="mt-5"
      >
        <template slot="header">
          <h4 class="w-full m-2 my-4 clear-both">
            Last bad reviews on content
          </h4>
          <div class="reviews__filters flex w-full mb-5">
            <div class="w-1/3 mr-10 ml-auto">
              <label>From:</label>
              <datepicker
                v-model="contentDateFrom"
                @input="changeContentRatingsDateFilter"
              ></datepicker>
            </div>
            <div class="w-1/3">
              <label>To:</label>
              <datepicker
                v-model="contentDateTo"
                @input="changeContentRatingsDateFilter"
              ></datepicker>
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th sort-key="content">Content</vs-th>
          <vs-th sort-key="model_type">Content type</vs-th>
          <vs-th sort-key="rating">Rating</vs-th>
          <vs-th sort-key="instructor">Instructor</vs-th>
          <vs-th sort-key="instructor_rating">Rating</vs-th>
          <vs-th sort-key="learning-area">Learning Area</vs-th>
          <vs-th sort-key="created">Created</vs-th>
          <vs-th sort-key="observation">Comments</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="review"
            :key="indextr"
            v-for="(review, indextr) in data"
            class="review"
          >
            <vs-td :data="review.name">{{ review.name }}</vs-td>

            <vs-td :data="review.model_type">{{
              capitalize(review.model_type)
            }}</vs-td>

            <vs-td :data="review.rating">
              <rating-stars
                :ref="`ref_content_${review.id}_${review.model_id}`"
                @mouseenter.native="
                  showStarWidget(
                    `ref_content_${review.id}_${review.model_id}`,
                    review.model_id,
                    review.model_type
                  )
                "
                @mouseleave.native="widgetActive = false"
                :rating="parseInt(review.rating)"
              />
            </vs-td>

            <vs-td :data="review.instructor_data.name">
              {{ review.instructor_data.name || 'N/A' }}
            </vs-td>

            <vs-td :data="review.instructor_data.avg_rating">
              <rating-stars
                v-if="review.instructor_rating"
                :ref="`ref_content_${review.id}_${review.instructor_data.id}`"
                @mouseenter.native="
                  showStarWidget(
                    `ref_content_${review.id}_${review.instructor_data.id}`,
                    review.instructor_data.id,
                    'instructor'
                  )
                "
                @mouseleave.native="widgetActive = false"
                :rating="parseInt(review.instructor_rating)"
              />
            </vs-td>

            <vs-td :data="review.learning_areas">{{
              review.learning_areas.map((la) => la.name).join(', ')
            }}</vs-td>

            <vs-td :data="review.created">{{
              review.created | dateFormat
            }}</vs-td>

            <vs-td :data="review.observations">
              <vx-tooltip
                v-if="review.observations"
                :text="review.observations"
              >
                <div class="review__observations">
                  {{ review.observations }}
                </div>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table-m>
    </div>

    <div class="w-full search-instructors-loading vs-con-loading__container">
      <vs-table-m
        @change-page="handleChangePageInstructorsRatings"
        :sst="true"
        :total="instructorsRatings.total"
        :maxItems="pageSizeInstructorsRatings"
        :data="instructorsRatings.items"
        pagination
        class="mt-10"
      >
        <template slot="header">
          <h4 class="w-full m-2 my-4 clear-both">
            Last bad reviews on instructors
          </h4>
          <div class="reviews__filters flex w-full mb-5">
            <div class="w-1/3 mr-10 ml-auto">
              <label>From:</label>
              <datepicker
                v-model="instructorsDateFrom"
                @input="changeInstructorsDateFilter"
              ></datepicker>
            </div>
            <div class="w-1/3">
              <label>To:</label>
              <datepicker
                v-model="instructorsDateTo"
                @input="changeInstructorsDateFilter"
              ></datepicker>
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th sort-key="instructor">Instructor</vs-th>
          <vs-th sort-key="instructor_rating">Rating</vs-th>
          <vs-th sort-key="content">Content</vs-th>
          <vs-th sort-key="rating">Rating</vs-th>
          <vs-th sort-key="learning-area">Learning Area</vs-th>
          <vs-th sort-key="created">Created</vs-th>
          <vs-th sort-key="observation">Comments</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="review"
            :key="indextr"
            v-for="(review, indextr) in data"
            class="review"
          >
            <vs-td :data="review.instructor_data.name">
              {{ review.instructor_data.name || 'N/A' }}
            </vs-td>

            <vs-td :data="review.instructor_data.avg_rating">
              <rating-stars
                v-if="review.instructor_rating"
                :ref="`ref_instructors_${review.id}_${review.instructor_data.id}`"
                @mouseenter.native="
                  showStarWidget(
                    `ref_instructors_${review.id}_${review.instructor_data.id}`,
                    review.instructor_data.id,
                    'instructor'
                  )
                "
                @mouseleave.native="widgetActive = false"
                :rating="parseInt(review.instructor_rating)"
              />
            </vs-td>

            <vs-td :data="review.name">{{ review.name }}</vs-td>

            <vs-td :data="review.avg_rating">
              <rating-stars
                :ref="`ref_instructors_${review.id}_${review.model_id}`"
                @mouseenter.native="
                  showStarWidget(
                    `ref_instructors_${review.id}_${review.model_id}`,
                    review.model_id,
                    review.model_type
                  )
                "
                @mouseleave.native="widgetActive = false"
                :rating="parseInt(review.rating)"
              />
            </vs-td>

            <vs-td :data="review.learning_areas">{{
              review.learning_areas.map((la) => la.name).join(', ')
            }}</vs-td>

            <vs-td :data="review.created">{{
              review.created | dateFormat
            }}</vs-td>

            <vs-td :data="review.observations">
              <vx-tooltip
                v-if="review.observations"
                :text="review.observations"
              >
                <div class="review__observations">
                  {{ review.observations }}
                </div>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table-m>
    </div>

    <div class="w-1/2 search-worst-loading vs-con-loading__container pb-20">
      <vs-table-m
        @change-page="handleChangePageWorstInstructors"
        :sst="true"
        :total="worstInstructors.total"
        :maxItems="pageSizeWorstInstructors"
        :data="worstInstructors.items"
        pagination
        class="mt-5 mb-10"
      >
        <template slot="header">
          <h4 class="m-2 my-4">The worst instructors</h4>
        </template>
        <template slot="thead">
          <vs-th sort-key="name">Instructor Name</vs-th>
          <vs-th sort-key="name">Avg Rating</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="instructor"
            :key="indextr"
            v-for="(instructor, indextr) in data"
          >
            <vs-td :data="instructor.name">{{ instructor.name }}</vs-td>

            <vs-td :data="instructor.avg_rating">
              <rating-stars
                v-if="instructor.avg_rating"
                :ref="`ref_worst_instructors_${instructor.id}`"
                @mouseenter.native="
                  showStarWidget(
                    `ref_worst_instructors_${instructor.id}`,
                    instructor.id,
                    'instructor'
                  )
                "
                @mouseleave.native="widgetActive = false"
                :rating="parseFloat(instructor.avg_rating)"
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table-m>
    </div>
    <rating-widget
      v-if="widgetActive || widgetHover"
      :style="widgetPosition"
      :content_id="widgetContentId"
      :content_type="widgetContentType"
      @mouseenter.native="widgetHover = true"
      @mouseleave.native="widgetHover = false"
    />
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
import VsTableM from '@/components/VsTableM'
import RatingStars from '@/components/RatingStars.vue'
import RatingWidget from '@/components/RatingWidget.vue'
import { starsWidget } from '@/utils/mixins.js'
import { capitalize } from '@/utils/utils.js'

export default {
  name: 'Reviews',
  components: {
    VsTableM,
    RatingStars,
    RatingWidget,
    Datepicker,
  },
  mixins: [starsWidget],
  data: () => {
    return {
      pageSizeContentRatings: 5,
      currentCoursesRatingsPage: 1,
      pageSizeInstructorsRatings: 5,
      currentInstructorsRatingsPage: 1,
      pageSizeWorstInstructors: 5,
      currentWorstInstructorsPage: 1,
      contentRatings: {
        total: 0,
        items: [],
      },
      instructorsRatings: {
        total: 0,
        items: [],
      },
      worstInstructors: {
        total: 0,
        items: [],
      },
      starsConfig: {
        rating: 0,
        isIndicatorActive: false,
        style: {
          fullStarColor: '#ed8a19',
          emptyStarColor: '#737373',
          starWidth: 10,
          starHeight: 10,
        },
      },
      contentDateFrom: dayjs().subtract(3, 'month').toDate(),
      contentDateTo: new Date(),
      instructorsDateFrom: dayjs().subtract(3, 'month').toDate(),
      instructorsDateTo: new Date(),
    }
  },
  methods: {
    ...mapActions('ratings', ['searchRatings', 'getRatingsCSV']),
    ...mapActions('instructors', ['searchInstructors']),
    ...mapActions('courses', ['searchCoursesWithoutAdapter']),
    ...mapActions('lpaths', ['searchLPathsWithoutAdapter']),
    capitalize,
    async handleChangePageContentRatings(page) {
      this.currentCoursesRatingsPage = page
      this.lastContentRatings({
        page: this.currentCoursesRatingsPage.toString(),
      })
    },
    async handleChangePageInstructorsRatings(page) {
      this.currentInstructorsRatingsPage = page
      this.lastInstructorsRatings({
        page: this.currentInstructorsRatingsPage.toString(),
      })
    },
    async handleChangePageWorstInstructors(page) {
      this.currentWorstInstructorsPage = page
      this.theWorstInstructors({
        page: this.currentWorstInstructorsPage.toString(),
      })
    },
    async theWorstInstructors(payload) {
      payload = {
        ...payload,
        page_size: this.pageSizeWorstInstructors.toString(),
        ordering: 'avg_rating',
      }
      this.$vs.loading({
        container: '.search-worst-loading',
        scale: 0.6,
      })
      const response = await this.searchForInstructors(payload)
      this.$vs.loading.close('.search-worst-loading > .con-vs-loading')
      this.worstInstructors.total = response ? response.count : 0
      this.worstInstructors.items = response ? response.results : []
    },
    async lastContentRatings(payload) {
      payload = {
        ...payload,
        page_size: this.pageSizeContentRatings.toString(),
        ordering: 'rating,created',
        created_after: dayjs(this.contentDateFrom).format('YYYY-MM-DD'),
        created_before: dayjs(this.contentDateTo)
          .add(1, 'day')
          .format('YYYY-MM-DD'), // to 00:00:00 of next day.
      }
      this.$vs.loading({
        container: '.search-content-loading',
        scale: 0.6,
      })
      const response = await this.search(payload)

      if (response.results) await this.populateContentRatings(response.results)
      this.$vs.loading.close('.search-content-loading > .con-vs-loading')
      this.contentRatings.total = response ? response.count : 0
      this.contentRatings.items = response ? response.results : []
    },
    async populateContentRatings(results) {
      const contentNamesSet = new Map()
      const idsMap = {
        course: [],
        'learning-path': [],
      }
      results.forEach((result) => {
        idsMap[result.model_type].push(result.model_id)
      })

      if (idsMap.course.length) {
        const courses = await this.getCoursesByIds(idsMap.course)

        courses.forEach((course) => {
          contentNamesSet.set(course.id, course)
        })
      }
      if (idsMap['learning-path'].length) {
        const learningPaths = await this.getLearningPathsByIds(
          idsMap['learning-path']
        )
        learningPaths.forEach((lp) => {
          contentNamesSet.set(lp.id, lp)
        })
      }

      results.forEach((result) => {
        if (contentNamesSet.has(result.model_id)) {
          const { name, learning_areas } = contentNamesSet.get(result.model_id)
          Object.assign(result, { name, learning_areas })
        }
      })
    },
    async getCoursesByIds(ids) {
      try {
        const { results } = await this.searchCoursesWithoutAdapter({ ids })
        return results
      } catch (error) {
        this.showError(error)
        return []
      }
    },
    async getLearningPathsByIds(ids) {
      try {
        const { results } = await this.searchLPathsWithoutAdapter({ ids })
        return results
      } catch (error) {
        this.showError(error)
        return []
      }
    },
    async lastInstructorsRatings(payload) {
      payload = {
        ...payload,
        page_size: this.pageSizeInstructorsRatings.toString(),
        ordering: 'instructor_rating,created',
        created_after: dayjs(this.instructorsDateFrom).format('YYYY-MM-DD'),
        created_before: dayjs(this.instructorsDateTo)
          .add(1, 'day')
          .format('YYYY-MM-DD'), // to 00:00:00 of next day.
      }
      this.$vs.loading({
        container: '.search-instructors-loading',
        scale: 0.6,
      })
      const response = await this.search(payload)
      if (response.results) await this.populateContentRatings(response.results)

      this.$vs.loading.close('.search-instructors-loading > .con-vs-loading')
      this.instructorsRatings.total = response ? response.count : 0
      this.instructorsRatings.items = response ? response.results : []
    },
    async changeContentRatingsDateFilter() {
      await this.lastContentRatings()
    },
    async changeInstructorsDateFilter() {
      await this.lastInstructorsRatings()
    },
    async search(payload = {}) {
      try {
        const response = await this.searchRatings(payload)
        return response
      } catch (error) {
        this.showError(error)
      }
    },
    async searchForInstructors(payload = {}) {
      try {
        const response = await this.searchInstructors(payload)
        return response
      } catch (error) {
        this.showError(error)
      }
    },
    async downloadReviews() {
      const response = await this.getRatingsCSV()
      let blob = new Blob([response.data], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = response.filename
      link.click()
    },
  },

  async mounted() {
    try {
      this.$vs.loading()

      this.$nextTick().then(() => {
        this.$vs.loading.close()
      })

      this.lastContentRatings()

      this.lastInstructorsRatings()

      this.theWorstInstructors()

      // Load the static filtered searches
    } catch (error) {
      this.$vs.loading.close()
      this.showError(error)
    }
  },
}
</script>
<style lang="scss" scoped>
.review {
  &__observations {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
